import React from "react";
import { NOTICE_LIGHT } from "@streeteasy/design-system/colors";
import { bool, number } from "prop-types";

import { List, ListItem } from "../HeaderNavDropdownList";
import { useMainNavDropdown } from "../MainNav/hooks";
import { DEFAULT_DROPDOWN_TITLE } from "./constants";
import * as S from "./styled";

const ExpertToolsDropdown = ({
  belongs_to_rmc,
  experts_teams_enabled,
  is_expert_suspended,
  is_small_landlord,
  new_connections_count,
  user_is_on_experts_team
}) => {
  const {
    dropdownRef,
    isActive,
    onClick,
    onMouseEnter,
    onMouseLeave
  } = useMainNavDropdown();

  if (is_small_landlord) {
    return null;
  }

  const AttentionMark = is_expert_suspended ? (
    <svg
      height={8}
      style={{ position: "relative", top: -6, left: -4 }}
      width={8}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx={4} cy={4} fill={NOTICE_LIGHT} r={4} />
    </svg>
  ) : null;
  const ConnectionsLink = (
    <ListItem
      isAttention={is_expert_suspended}
      link="/manage/experts/connections?nav_agent_tools"
      title={
        <>
          Connections
          {new_connections_count > 0 ? (
            <S.ConnectionsCount
              aria-label={`${new_connections_count} new connection${
                new_connections_count > 1 ? "s" : ""
              }`}
            >
              {new_connections_count}
            </S.ConnectionsCount>
          ) : null}
        </>
      }
    />
  );
  const MyBuildingsLink = (
    <ListItem
      link="/manage/experts/my_buildings?nav_agent_tools"
      title="My Buildings"
    />
  );
  const TransactionsLink = (
    <ListItem
      link="/manage/experts/transactions?nav_agent_tools"
      title="Transactions"
    />
  );
  const MyTeamLink =
    experts_teams_enabled && user_is_on_experts_team ? (
      <ListItem
        link="/manage/experts/my_team?nav_agent_tools"
        title="My Team"
      />
    ) : null;
  const BillingHistoryLink = belongs_to_rmc ? (
    <ListItem
      link="/manage/property_management/dashboard/billing_history?site=nyc"
      title="Billing History"
    />
  ) : null;
  const ResourceCenterLink = (
    <ListItem
      link="https://streeteasy.com/expert-resources"
      title="Resource Center"
    />
  );

  return (
    <>
      <S.ExpertsDropdownButton
        aria-expanded={isActive}
        aria-haspopup="true"
        aria-label={DEFAULT_DROPDOWN_TITLE}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {AttentionMark}
        {DEFAULT_DROPDOWN_TITLE} &nbsp;
        <S.CaretIcon />
      </S.ExpertsDropdownButton>
      <div ref={dropdownRef}>
        <S.StyledMenuPopup
          isActive={isActive}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}
          role="tooltip"
        >
          <List>
            {ConnectionsLink}
            {MyBuildingsLink}
            {TransactionsLink}
            {MyTeamLink}
            {BillingHistoryLink}
            {ResourceCenterLink}
          </List>
        </S.StyledMenuPopup>
      </div>
    </>
  );
};

ExpertToolsDropdown.propTypes = {
  is_expert_suspended: bool,
  is_small_landlord: bool,
  belongs_to_rmc: bool,
  new_connections_count: number,
  user_is_on_experts_team: bool,
  experts_teams_enabled: bool
};

ExpertToolsDropdown.defaultProps = {
  is_expert_suspended: false,
  is_small_landlord: false,
  belongs_to_rmc: false,
  new_connections_count: 0,
  user_is_on_experts_team: false,
  experts_teams_enabled: false
};

export default ExpertToolsDropdown;
